import { UploadType } from "@/hooks/store/useStore";
import { AirdropResponse } from "@/services/rpc/near";

import { Achievement, TrustResponseData } from "../api";
import { Network } from "../network";
import { AirdropNFTProps, NFTNetworkProps } from "../nft";

export type RecheckModalStage = "loading" | "minting" | "same";

export interface NetworksData {
  network: Network;
  level: number;
  availableAction: boolean;
  retrievedScores?: TrustResponseData;
  accountId?: string; //TODO: make it required

  score: {
    value: number;
    isMinted: boolean;
    expirationDate: number | null;
    top1000: number | null;
    rating: number | null;
  };
  nft: NFTNetworkProps | null;
}

export interface AccountsProps {
  nearAccount: string | null;
  evmAccount: string | null;
  tonAccount: string | null;
  solanaAccount: string | null;
  stellarAccount: string | null;
}

export interface User extends AccountsProps {
  x: boolean;
  telegram: boolean;
  news: string | null;
  isWaitingMint: boolean;
  achievements: Array<Achievement>;
  networksData: Record<Network, NetworksData>;
  totalScore: number;
}

export interface Store {
  preload: boolean;
  network: Network;
  user: User;
  userLoading: boolean;
  uploadType: UploadType;
}

export type AirdropStatus = "soon" | "preActive" | "active" | "stopped" | "closed";
export const statusOrder: AirdropStatus[] = ["active", "preActive", "soon", "closed", "stopped"];

export interface AirdropProps extends AirdropResponse {
  holdTimeInDays: number;
  minAllowedScore: number;
  isHAPIBalanceRequired: boolean;
  status: AirdropStatus;
  nfts: Array<AirdropNFTProps> | null;
}
